module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAOxJREFUOE+lkzFOAmEQhb8XNbvZkBBj1lvQ2NBTYWFiQ6MkxtrWQm4gBTU1sFtRWFgRs9zAA3iF/78AYnSMFMaYXZZlp59vZt57I2qWavZTADDF13T9moy51tuG5AJO+nZ5IJ4wUvfODXN9FkHyN7iw6LTJM6JjxsQn3IIsD1KowXHPmkchC6CNMXYJd3mQrSL+QA5DloIzYORmuv+/RakLjZ7FUUgGtOyLgU/1+BeyGyAgQ7TMePCJhjsDNicELKU9TtiIGLBAtBFjN60iYl0bf4MEqVvtEyRM8RXn/o0XXvVROcpVHqzUxjLYN2bpUBEuc5EMAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/images2/go.png
// module id = PZaK
// module chunks = 1